import React from "react";
import { GrcCard, effectiveScore, effectiveRag, pillarsArray, priorityFor, ragColor, RAG_BG, isWorkflowPillar } from "./shared";

const RANK_BG = ["#D32F2F", "#F57C00", "#F57C00", "#FBC02D", "#FBC02D"];

export const WeakestPillars = ({ pillars, sdf, onPillarClick }) => {
  const ranked = pillarsArray(pillars)
    .map((p) => ({ ...p, eff: effectiveScore(p, sdf), effRag: effectiveRag(p, sdf) }))
    .filter((p) => p.eff != null)
    .sort((a, b) => a.eff - b.eff)
    .slice(0, 5);

  return (
    <GrcCard
      title="Weakest Pillars (Action Priority)"
      info="Bottom five pillars by score — your remediation priority order. Click a rank badge to inspect the pillar."
      infoTestId="info-weakest-pillars"
      testId="widget-weakest-pillars"
      className="lg:col-span-3"
    >
      <div className="space-y-2.5">
        {ranked.length === 0 && <div className="text-xs text-slate-500">No scored pillars yet.</div>}
        {ranked.map((p, i) => (
          <div
            key={p.code}
            data-testid={`weakest-pillar-${i + 1}`}
            className="rounded-lg border border-slate-200 p-2.5 space-y-1 hover:shadow-md transition-shadow duration-200"
          >
            <div className="flex items-center gap-2">
              <button
                type="button"
                data-testid={`weakest-rank-badge-${i + 1}`}
                onClick={() => onPillarClick?.(p.code)}
                className="w-6 h-6 rounded-md text-white text-xs font-bold shrink-0 hover:scale-105 transition-transform"
                style={{ backgroundColor: RANK_BG[i] }}
                aria-label={`Open ${p.code} detail`}
              >
                {i + 1}
              </button>
              <span className="text-xs font-semibold text-[#003366] whitespace-nowrap">
                {p.code}
              </span>
              <span className="flex-1 min-w-0" />
              <span
                className="text-right text-sm font-bold tabular-nums shrink-0 whitespace-nowrap"
                style={{ color: ragColor(p.effRag) }}
              >
                {p.eff}%
              </span>
            </div>
            {isWorkflowPillar(p.code) && (
              <span
                data-testid={`workflow-badge-${p.code}`}
                title="Non-scoring workflow pillar"
                className="inline-flex items-center rounded-full bg-[#008080]/10 text-[#008080] text-[9px] font-semibold uppercase tracking-wider px-1.5 py-0.5 border border-[#008080]/20 ml-8"
              >
                Workflow
              </span>
            )}
            <div className="text-[11px] text-slate-700 leading-snug">{p.name}</div>
            <div className="flex items-center justify-between gap-2">
              <span className="text-[10px] text-slate-400 leading-snug">{priorityFor({ ...p, rag: p.effRag })}</span>
              <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded shrink-0 ${RAG_BG[p.effRag] || RAG_BG.AMBER}`}>
                {p.effRag}
              </span>
            </div>
          </div>
        ))}
      </div>
    </GrcCard>
  );
};
